var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEditMeta22X22 = function SvgEditMeta22X22(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "main-stroke-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon feather-edit-2",
    d: "M17.448 2.157a3.101 3.101 0 0 1 4.386 4.386l-14.8 14.8L1 22.991l1.645-6.031Z",
    fill: "none"
  })));
};
export default SvgEditMeta22X22;